import { useAnalytics } from '@/app/context/AnalyticsContext/AnalyticsContext'
import { useAppStore } from '../store'
import { Page } from '@/shared/constants'

const useEnterPageLogAnalytics = (pageEnter: Page) => {
    const { previousPage } = useAppStore()
    const Analytics = useAnalytics()
    Analytics?.analyticsLogEvent(`enter ${pageEnter} page`, {
        from: previousPage,
    })
}

export default useEnterPageLogAnalytics
